import Link from 'next/link';
import Head from 'next/head';

import {
  ToolsHeaderCode,
  ToolsHeaderTitleCode,
} from '@/components/codeHighlights/NavigationCode';
import { GetPathName } from '@/lib/helpers';
import ToolsHeaderDemo from '@/components/nav/ToolsHeaderDemo';
import NavBarTitle from '@/components/nav/NavBarTitle';

const Page = () => {
  return (
    <>
      <Head>
        <title>Tools-Header</title>
      </Head>
      <h1>Tools-Header</h1>
      <p className="lead">
        Der Tools-Header stellt einen Header mit integrierter Navigation für
        FHNW-interne Plattformen zur Verfügung.
      </p>
      <ul>
        <li>
          Einfacher Dropdown (vgl. obiger Navigationspunkt "
          <Link
            href={`${process.env.NEXT_PUBLIC_BASE_URL}/corporate-design/tools-and-services`}
            legacyBehavior
          >
            <a href="">Corporate Design</a>
          </Link>
          ")
        </li>
        <li>
          Mega-Menu (vgl. obige Navigationspunkte “Basiselemente” und
          “Komponenten”)
        </li>
      </ul>
      <p>
        Der hier dargestellte Tools-Header integriert ausserdem Login- und
        Sprachumschalt-Funktionalität. Entsprechende UI-Elemente sind hier
        beispielhaft dargestellt.
      </p>
      <h2>Tools-Header mit allen Optionen und Varianten</h2>
      <div className="mt-5">
        <ToolsHeaderDemo />
      </div>
      <div className="mt-3 mb-5">
        <ToolsHeaderCode />
      </div>

      <h2>Tools-Header mit Projekttitel</h2>
      <p>
        Dieses Beispiel dient für Projekte die keine Navigationseinheiten
        benötigen und der Projekttitel hervorgehoben werden soll.
      </p>
      <p>
        <strong>Hinweis:</strong> Sofern keine weiteren Navigationelemente
        enthalten sind muss für den Container NAV explizit eine Höhe von 60px
        gesetzt werden.
      </p>
      <div className="mt-5">
        <NavBarTitle />
      </div>
      <div className="mt-3">
        <ToolsHeaderTitleCode />
      </div>
    </>
  );
};

export default Page;
